import { memo, type ReactNode } from 'react';

import { FullscreenHeader } from '~/components/AssetModalV2/Visualizer/shared/components/FullscreenHeader';

export type FullscreenOverlayProps = {
  headerCenterAccessory?: ReactNode;
  modeToggleSegmentedControl: ReactNode;
  navigationArrows: ReactNode;
  showModeToggle?: boolean;
};

export const FullscreenOverlay = memo(
  ({
    headerCenterAccessory,
    navigationArrows,
    showModeToggle = true,
    modeToggleSegmentedControl,
  }: FullscreenOverlayProps) => {
    return (
      <>
        <div className="fixed top-2 left-0 z-[9999] flex w-full justify-center px-4">
          <FullscreenHeader centerAccessory={headerCenterAccessory} navigationArrows={navigationArrows} />
        </div>
        {showModeToggle && modeToggleSegmentedControl ? (
          <div className="fixed bottom-8 left-0 z-[9999] flex w-full justify-center">{modeToggleSegmentedControl}</div>
        ) : null}
      </>
    );
  },
);

FullscreenOverlay.displayName = 'FullscreenOverlay';
